module.exports = "mutation ($id: ID!, $data: ResidentialTemplateSyncOptions!) {\n  ResidentialTemplateSync(id: $id, data: $data)\n}\n"